/* VialCase lid-design cart guard (owner 2026-10-16, order vc9486: the lid design add-on line was removed in the cart and the case still
   checked out WITH its design, unpaid - "remove the whole case from the cart with warning pop up").
   A case line carrying a product-page lid design (_lid_ref) needs its Custom Lid Design add-on (same _lid_ref, at least the same quantity);
   otherwise the WHOLE case line is removed and a pop-up explains why. An add-on line whose case is gone is removed too (nobody pays for a lid
   with no case). Builder custom cases carry no _lid_ref (their lid fee is inside the quote) and are never touched.
   2026-10-18 (order vc9504: the cart's "Complete Your Setup" card added a bare $9.99 Custom Lid Design - no design, no _lid_ref - and nothing
   asked the customer what to put on the lid): a Custom Lid Design line WITHOUT _lid_ref is removed with a pop-up that says how to add a lid
   design, and so is a design-only builder product (custom case / caps / pill box price step) that arrives without the property its builder
   adds - the farm has nothing to make from either.
   2026-10-19 (owner: "if they remove it, it drops the design from the cart and the design completely" + keep the case): removing the
   Custom Lid Design line no longer removes the case - the designed case line is swapped for a PLAIN line of the same variant and
   quantity (no Lid design / _lid / _lid_ref / Final sale), with a short note. And the add-on quantity now FOLLOWS the case quantity
   (one lid design charged per designed case): raising a designed case from 2 to 3 used to remove the case (2 paid < 3) and then its
   orphaned add-on, emptying the cart.
   Runs on every page load and after every cart change made with fetch (add / change / update / clear). */
(function () {
  if (window.__vcLidGuard) return;
  window.__vcLidGuard = true;
  var ADDON = 'custom-lid-design', KEY = 'vcLidGuardMsg', busy = false, timer = null, origFetch = window.fetch.bind(window);
  // design-only products: handle -> [the line property its builder always adds, the builder page]
  var BUILT = {'custom-vial-case': ['_spec', '/pages/build-your-case'], 'custom-vial-caps': ['_caps', '/pages/build-your-caps'],
               'custom-pill-box': ['_spec', '/pages/build-your-pill-box'], 'custom-ammo-case': ['_spec', '/pages/build-your-ammo-case']};

  function isAddon(it) { return it.handle === ADDON || it.sku === 'LID-DESIGN'; }
  function ref(it) { return it.properties && it.properties._lid_ref; }
  function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;'}[c]; }); }

  // msg = {cases: [case titles], lid: true when a bare lid add-on went, built: [[title, builder url]]}
  function show(msg) {
    var cases = msg.cases || [], built = msg.built || [], parts = [], title;
    if (cases.length) {
      parts.push('<p style="margin:0 0 10px">The lid design was removed, so <b>' + cases.map(esc).join(', ') + '</b> '
        + (cases.length > 1 ? 'stay' : 'stays') + ' in your cart as a plain case, without a design. To add a design again, open the case and tap '
        + '<b>Add your logo or text to the lid</b> (the lid fee is added for you).</p>');
    }
    if (msg.lid) {
      parts.push('<p style="margin:0 0 10px">The <b>Custom Lid Design</b> was added without a design, so we took it out of your cart - we would not know '
        + 'what to put on your lid. A lid design is made together with its case:</p>'
        + '<p style="margin:0 0 10px">&bull; <b>Custom case:</b> tap <b>Edit this case</b> in your cart and add your text or icon to the lid in the Case Builder.<br>'
        + '&bull; <b>Any other case:</b> open the case and tap <b>Add your logo or text to the lid</b>.</p>'
        + '<p style="margin:0 0 10px">The lid fee is added for you once your design is on.</p>');
    }
    built.forEach(function (b) {
      parts.push('<p style="margin:0 0 10px"><b>' + esc(b[0]) + '</b> is made from your design, so it can only be added from its builder. '
        + '<a href="' + esc(b[1]) + '" style="color:#5b3fd6;font-weight:700">Open the builder</a></p>');
    });
    if (!parts.length) {
      parts.push('<p style="margin:0 0 10px">A custom item in your cart was missing its design, so we took it out of your cart.</p>');
    }
    title = cases.length && !msg.lid && !built.length ? 'Lid design removed'
          : msg.lid && !cases.length && !built.length ? 'Custom lid needs your design'
          : 'Custom item removed from your cart';
    var wrap = document.createElement('div');
    wrap.setAttribute('role', 'alertdialog'); wrap.setAttribute('aria-modal', 'true'); wrap.setAttribute('aria-labelledby', 'vc-lg-t');
    wrap.style.cssText = 'position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:16px;background:rgba(10,12,20,.55)';
    wrap.innerHTML = '<div style="max-width:420px;width:100%;max-height:90vh;overflow:auto;background:#fff;color:#14182b;border-radius:14px;padding:22px 20px;box-shadow:0 18px 50px rgba(0,0,0,.35);font:15px/1.45 system-ui,-apple-system,Segoe UI,sans-serif">'
      + '<div id="vc-lg-t" style="font-size:18px;font-weight:800;margin-bottom:8px">' + title + '</div>'
      + parts.join('')
      + '<button type="button" style="width:100%;margin-top:6px;padding:12px 16px;border:0;border-radius:10px;background:#14182b;color:#fff;font-weight:700;font-size:15px;cursor:pointer">OK</button></div>';
    document.body.appendChild(wrap);
    var btn = wrap.querySelector('button'), close = function () { wrap.remove(); };
    btn.addEventListener('click', close);
    wrap.addEventListener('click', function (e) { if (e.target === wrap) close(); });
    document.addEventListener('keydown', function k(e) { if (e.key === 'Escape') { close(); document.removeEventListener('keydown', k); } });
    btn.focus();
  }

  // product-page designs always carry _lid + _lid_ref; 'Lid design' alone is a display label the builders (case / ammo) also set,
  // their lid fee is inside their own price - never treat those as a product-page design (2026-10-19 audit: ammo lines lost _spec)
  function hasDesign(it) { var p = it.properties || {}; return !!(p._lid || p._lid_ref); }

  function check() {
    if (busy) return;
    busy = true;
    origFetch('/cart.js', {credentials: 'same-origin', headers: {Accept: 'application/json'}}).then(function (r) { return r.json(); }).then(function (cart) {
      var addons = {}, cases = {}, upd = {}, plain = [], msg = {cases: [], lid: false, built: []}, n = 0;
      (cart.items || []).forEach(function (it) {
        var r = ref(it); if (!r) return;
        if (isAddon(it)) (addons[r] = addons[r] || []).push(it); else cases[r] = (cases[r] || 0) + it.quantity;
      });
      (cart.items || []).forEach(function (it) {
        var r = ref(it), b = BUILT[it.handle];
        if (isAddon(it)) {
          if (!r) { upd[it.key] = 0; n++; msg.lid = true; }          // no design anywhere: nothing to print on the lid
          else if (!cases[r]) { upd[it.key] = 0; n++; }              // its case is gone
        }
        else if (b) {
          if (!(it.properties && it.properties[b[0]])) { upd[it.key] = 0; n++; msg.built.push([it.product_title, b[1]]); }
        }
        else if (hasDesign(it) && !(r && addons[r])) {
          // the lid design was removed (or never paid): drop the DESIGN, keep the case - a plain line of the same variant + quantity
          upd[it.key] = 0; plain.push({id: it.variant_id, quantity: it.quantity}); n++; msg.cases.push(it.product_title);
        }
      });
      // one lid design per designed case: the add-on quantity follows the case quantity (up and down)
      Object.keys(addons).forEach(function (r) {
        if (!cases[r]) return;
        addons[r].forEach(function (a, i) {
          var q = i === 0 ? cases[r] : 0;
          if (a.quantity !== q && upd[a.key] === undefined) { upd[a.key] = q; n++; }
        });
      });
      if (!n) { busy = false; return; }
      var post = function (url, body) {
        return origFetch(url, {method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json', Accept: 'application/json'},
                                body: JSON.stringify(body)});
      };
      return post('/cart/update.js', {updates: upd}).then(function () {
        return plain.length ? post('/cart/add.js', {items: plain}) : null;
      }).then(function () {
        if (msg.cases.length || msg.lid || msg.built.length) { try { sessionStorage.setItem(KEY, JSON.stringify(msg)); } catch (e) {} }
        location.reload();
      });
    }).catch(function () { busy = false; });
  }

  // CONFIRM before a lid design leaves the cart (owner 2026-10-19 "make confirmation"): the cart's Remove on a Custom Lid Design line asks
  // first; its +/- explain that the design count follows the case quantity. Capture phase on document = before the buttons' inline onclick.
  function dialog(title, html, buttons) {
    var wrap = document.createElement('div');
    wrap.setAttribute('role', 'alertdialog'); wrap.setAttribute('aria-modal', 'true'); wrap.setAttribute('aria-labelledby', 'vc-lc-t');
    wrap.style.cssText = 'position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:16px;background:rgba(10,12,20,.55)';
    wrap.innerHTML = '<div style="max-width:420px;width:100%;background:#fff;color:#14182b;border-radius:14px;padding:22px 20px;box-shadow:0 18px 50px rgba(0,0,0,.35);font:15px/1.45 system-ui,-apple-system,Segoe UI,sans-serif">'
      + '<div id="vc-lc-t" style="font-size:18px;font-weight:800;margin-bottom:8px">' + title + '</div>' + html
      + '<div style="display:flex;gap:10px;margin-top:12px">' + buttons.map(function (b, i) {
          return '<button type="button" data-i="' + i + '" style="flex:1;padding:12px 14px;border-radius:10px;font-weight:700;font-size:15px;cursor:pointer;'
            + (b.primary ? 'border:0;background:#14182b;color:#fff' : 'border:1.5px solid #c9cde0;background:#fff;color:#14182b') + '">' + esc(b.label) + '</button>';
        }).join('') + '</div></div>';
    document.body.appendChild(wrap);
    var done = function (i) { wrap.remove(); if (i != null && buttons[i].run) buttons[i].run(); };
    wrap.querySelectorAll('button').forEach(function (b) { b.addEventListener('click', function () { done(+b.getAttribute('data-i')); }); });
    wrap.addEventListener('click', function (e) { if (e.target === wrap) done(null); });
    document.addEventListener('keydown', function k(e) { if (e.key === 'Escape') { done(null); document.removeEventListener('keydown', k); } });
    var first = wrap.querySelector('button'); if (first) first.focus();
  }
  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('button, a') : null;
    if (!el || el.__vcLidOk) return;
    var lab = el.getAttribute('aria-label') || '';
    if (/^remove custom lid design/i.test(lab)) {
      e.preventDefault(); e.stopImmediatePropagation();
      dialog('Remove your lid design?',
        '<p style="margin:0">Your case stays in your cart, without a design, and the lid design fee comes off. You can add a design again from the case page.</p>',
        [{label: 'Keep my design', primary: true}, {label: 'Remove design', run: function () { el.__vcLidOk = true; el.click(); el.__vcLidOk = false; }}]);
    } else if (/^(increase|decrease) quantity for custom lid design/i.test(lab)) {
      e.preventDefault(); e.stopImmediatePropagation();
      dialog('One lid design per case',
        '<p style="margin:0">The lid design quantity always matches its case. Change the <b>case</b> quantity and the design follows; to drop the design, tap the bin next to it.</p>',
        [{label: 'OK', primary: true}]);
    }
  }, true);

  // re-check after any cart change the theme (or anything else) makes with fetch
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch(input, init);
    if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
      p.then(function () { clearTimeout(timer); timer = setTimeout(check, 400); }, function () {});
    }
    return p;
  };

  function boot() {
    var msg = null;
    try { msg = sessionStorage.getItem(KEY); sessionStorage.removeItem(KEY); } catch (e) {}
    if (msg) {
      try { msg = JSON.parse(msg); } catch (e) { msg = {}; }
      show(Array.isArray(msg) ? {cases: msg} : (msg || {}));     // an array = a message stored by the 10-16 guard
    }
    check();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
